/* src/assets/styles/common.css */
.flex {
  display: flex;
}
.flex-row {
  flex-direction: row;
}
.flex-column {
  flex-direction: column;
}
.flex.jc-e {
  justify-content: end;
}
.flex.jc-c {
  justify-content: center;
}
.flex.jc-sb {
  justify-content: space-between;
}
.flex.align-c {
  align-items: center;
}
.flex.align-fe {
  align-items: flex-end;
}
.flex.align-fs {
  align-items: flex-start;
}
.flex.gap-10 {
  gap: 10px;
}
.flex.gap-20 {
  gap: 20px;
}
.flex.gap-50 {
  gap: 50px;
}
.ac-fs {
  align-content: flex-start;
}
.text-align-center {
  text-align: center;
}
.text-align-right {
  text-align: right;
}
.container {
  padding: 1rem;
}
.mg-t-5 {
  margin-top: 5px;
}
.mg-t-10 {
  margin-top: 10px;
}
.mg-r-10 {
  margin-top: 20px;
}
.width100 {
  width: 100%;
}
.width90 {
  width: 90%;
}
.bold {
  font-weight: 800;
}
.col-1 {
  width: calc(100% * 1 / 12);
}
.col-2 {
  width: calc(100% * 2 / 12);
}

/* src/app/modules/tube/components/tube-card/tube-card.component.scss */
app-tube-timeline {
  margin-top: 0.5rem;
  height: 100%;
}
.tube-timeline {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0.5rem;
}
.tube-info {
  flex: 0.8;
}
.replacement-part-link {
  text-decoration: none;
}
.layout {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
  max-width: 100%;
}
:not([screen-phone]) :host-context .tube-info {
  max-width: calc(50% - 1px - 1rem);
}
:not([screen-phone]) :host-context .tube-timeline {
  padding-right: 0.5rem;
  border-right: 1px solid #c4c4c4;
}
:not([screen-phone]) :host-context .tube-info {
  padding-left: 0.5rem;
}
sh-button {
  width: 9.8rem;
  left: -0.5rem;
}
[screen-phone] :host-context .tube-timeline,
[screen-phone] :host-context .tube-info {
  min-width: 100%;
}
[screen-phone] :host-context .tube-timeline {
  border-bottom: 1px solid #c4c4c4;
  padding-bottom: 1rem;
}
[screen-phone] :host-context .tube-info {
  padding-bottom: 1rem;
  padding-top: 1rem;
}
[screen-phone] :host-context #sh_currentScanCounter {
  width: 9rem;
}
[screen-phone] :host-context sh-button {
  left: -1rem;
}
/*# sourceMappingURL=tube-card.component.css.map */
